import { Box } from "@mui/material";
import React from "react";
import noImageAvailable from "./no-image-available.jpg";

export const EmptyImagePlaceholder = () => {
    return (
        <Box
            width="100%"
            height="100%"
            component="img"
            alt="No image available"
            src={noImageAvailable}
            border={theme => `1px solid ${theme.palette.divider}`}
            borderRadius={2}
        />
    );
};